export const userProfileCacheKeys = {
  fetch: ['users', 'details'],
};
